import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { Encounter } from "@/Patient/Models/MedicalSummary/Encounter";
import { SummaryPanelConsultationDropdown } from "./SummaryPanelConsultationDropdown";

import styles from "./SummaryPanelButtons.module.css";

interface ISummaryPanelButtonsProps {
    isMedicalSummaryPanelOpen?: boolean;
    hideOpenSummaryPanelLink?: boolean;
    onMedicalSummaryLinkClick?: () => void;
    onPopoutClick: () => void;
    cssClass?: string;
    encounter?: Encounter;
    onEditConsultationDetailsClick?: (consultationContextLookupId?: string) => void;
}

function SummaryPanelButtons(props: ISummaryPanelButtonsProps): JSX.Element {
    const handleContextTypeChanged = (selectedContextLookupId: string): void => {
        const employeeUIModel = sessionStore.getCurrentEmployee();
        const isSiteActive = employeeUIModel && employeeUIModel.Model.AssociatedSites?.some(siteId => siteId === props.encounter?.SiteId);

        if (props.encounter.AutoApprove) {
            props?.onEditConsultationDetailsClick(selectedContextLookupId);
        }
        else {
            const consultationDetailsRequestBody = {
                consultationDate: new Date(props.encounter.ConsultationDate.toString()),
                consultationTypeId: props.encounter.ConsultationTypeLookupId,
                consultationContextId: selectedContextLookupId,
                consultationSiteId: props.encounter.SiteId,
                consultationDepartmentId: props.encounter.CostCenterId,
                consultationIsActiveSite: isSiteActive,
                consultationIsActiveDepartment: isSiteActive && props.encounter.CostCenterId != null,
                appointmentId: props.encounter.AppointmentId ?? props.encounter.SuggestedAppointmentLinkId,
                enableAppointmentLinkSuggestions: props.encounter.EnableAppointmentLinkSuggestions
            };
            sessionStore.dispatch(LocalPatientOperations.MedicalNote.ConsultationDetailsPopupModify, consultationDetailsRequestBody);
        }
    };
    return (
        <div className={`${styles[props.cssClass] ?? ""}`}>
            {props.encounter && cacheStore.ClinicSettings.EnableDirectPatientProfileEdits &&
                !props.encounter?.IsSignedOff && (
                    <SummaryPanelConsultationDropdown
                        currentLookupId={props.encounter.ConsultationContextLookupId}
                        handleContextTypeChanged={handleContextTypeChanged}
                    />
            )
            }
            {!props.hideOpenSummaryPanelLink && (
                <a
                    data-cy="summaryPanel-toggle"
                    onClick={() => props.onMedicalSummaryLinkClick?.()}
                >
                    {props.isMedicalSummaryPanelOpen ? cacheStore.GetString("HideMedicalSummaryLabel") : cacheStore.GetString("ViewMedicalSummaryLabel")}
                </a>
            )}
            <a
                data-cy="summaryPanel-popout"
                onClick={() => props.onPopoutClick()}
                className={styles.secondScreenPopupLink}
            >
                <svg width="16" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.8125 6.25V2.5H8.53125"
                        stroke="#0070D2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.875 7L11.8125 2.5"
                        stroke="#0070D2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10.0625 9V13C10.0625 13.1326 10.0164 13.2598 9.93436 13.3536C9.85231 13.4473 9.74103 13.5 9.625 13.5H2.625C2.50897 13.5 2.39769 13.4473 2.31564 13.3536C2.23359 13.2598 2.1875 13.1326 2.1875 13V5C2.1875 4.86739 2.23359 4.74021 2.31564 4.64645C2.39769 4.55268 2.50897 4.5 2.625 4.5H6.125"
                        stroke="#0070D2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </a>
        </div>
    );
}

export { SummaryPanelButtons };
